export default {
  SET_MODAL_STATUS: 'recipientMasterModalSetModalStatus',
  SET_MODAL_HINT: 'recipientMasterModalSetModalHint',
  SET_CONFIRM_CALLBACK: 'recipientMasterModalSetConfirmCallback',
  SET_CANCEL_CALLBACK: 'recipientMasterModalSetCancelCallback',
}
